import React, {Component} from 'react';
import './Pillbox.css';

class Pillbox extends Component {
	render() {
		const {options = [], selected, onSelect} = this.props;
		return (
			<pillbox className="Pillbox">
				{options.map(option => (
					<button
						className={selected === option ? 'selected' : ''}
						key={option}
						onClick={() => onSelect && onSelect(option)}
					>{option}</button>
				))}
			</pillbox>
		);
	}
}

export default Pillbox;


// WEBPACK FOOTER //
// ./src/widgets/Pillbox.js